<template>
  <!-- <div class="favourites_block_holder" v-if="mobile">
    <div id="favourites_list" class="favourites" v-bind:style="leaderboardheight">
      <div class="search_bar_desktop leaderboardview">
        <div class="input-group search_map_desktop">
          <span class="input-group-addon map_addon_desktop" id="search-addon-map-desktop"><i class="icon-categories"></i></span>
          <select v-model="selectedCat" class="form-control" id="categoriesSelect" @click="categoriesMobile">
            <option v-for="cat in categories">{{cat}}</option>
          </select>
        </div>
      </div>
    </div>
  </div> -->

  <div class="search_bar_desktop leaderboardview">
    <div class="input-group search_map_desktop">
      <span class="input-group-addon map_addon_desktop" id="search-addon-map-desktop"><i class="icon-categories"></i></span>
      <select v-model="selectedCat" class="form-control" id="categoriesSelect">
        <option selected="All Categories" v-for="cat in categories">{{cat}}</option>
      </select>
    </div>
  </div>
</template>
<style>

</style>
<script>
import { mapGetters } from 'vuex'

export default{
  data: function () {
    return {
      selectedCat: 'All Categories'
    }
  },
  created () {
    this.selectedCat = this.category
  },
  computed: {
    ...mapGetters({
      category: 'selectedCat',
      categories: 'categories'
    })
  },
  watch: {
    selectedCat: function () {
      this.$store.dispatch('loadSelectedCat', this.selectedCat)
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/categories.vue